import { setGA4Event } from "@iewc/Store/Handlers/Utilities/CustomTracking";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { request } from "@insite/client-framework/Services/ApiService";

const emailsUrl = "/api/v1/instantregistration/createexistingaccount";

type SubmitInstantRegistrationFormParameter = {
    emailRecipients: string;
    leadSource: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitInstantRegistrationFormParameter, FormData>;

export const PopulateApiParameter: HandlerType = (props: any) => {
    const state = (props.getState() as any).customInstantRegistrationForm.fieldValues; 

    const payload = {
        AccountNumber: state.accountNumber,
        FirstName: state.instantRegFirstName,
        LastName: state.instantRegLastName,
        Email: state.instantRegEmail,
    } as any;

    props.apiParameter = {} as any;
    Object.keys(payload).forEach(key => {
        props.apiParameter[key] = payload[key];
    });

};

export function multipart<Parameter, Result = Parameter>(endpoint: string, formData: any) {   
    const customertype = "existing";
    const formType = "Create an Account";
    const formID = "instantRegistrationForm";
    const accountNumber = formData.AccountNumber;
    const industrySelection = "N/A";
    const businessType = "N/A";
    setGA4Event([], "createAccountSubmission", { customertype,formType,formID, accountNumber,industrySelection,businessType});
    
    return request<Result>(
        endpoint,
        "POST",
        { Accept: "application/json", "Content-Type": "application/json" },
        JSON.stringify(formData),
    );
}

export function submitInstantRegistrationFormApi(parameter: any) {
    return multipart<any, void>(`${emailsUrl}`, parameter);
}

export const SendDataToApi: HandlerType = async props => {
    await submitInstantRegistrationFormApi(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitInstantRegistrationForm = createHandlerChainRunner(chain, "SubmitContactForm");
export default submitInstantRegistrationForm;
